module.exports = __webpack_public_path__ + "static/media/168.8f48809c.jpg";